<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import Popup from "@components/popup/Popup.svelte"
    import PopupBanner from "@components/popup/PopupBanner.svelte"
    import PopupButtons from "@components/popup/PopupButtons.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import PopupIcon from "@components/popup/PopupIcon.svelte"
    import PopupIconDivider from "@components/popup/PopupIconDivider.svelte"
    import PopupWarning from "@components/popup/PopupWarning.svelte"

    export let info: {
        onskip: () => void
        onnow: () => void
        cancel: () => void
        number: number
    }

    $: plural = info.number >= 2
</script>

<Popup on:clickoutside={() => info.cancel()}>
    <PopupBanner>
        <PopupExit on:exit={() => info.cancel()} float />
        <PopupIconDivider>
            <div slot="icon">
                <PopupIcon class="text-2xl dark:text-black bg-blue-100" icon="lotus" />
            </div>
            <PopupHeading>
                {#if plural}
                    Some reminders are over an hour old.
                {:else}
                    One reminder is over an hour old.
                {/if}
            </PopupHeading>
        </PopupIconDivider>
    </PopupBanner>
    <p>
        {#if plural}
            Would you like to return to the latest practice reminder now, or skip the older ones?
        {:else}
            Would you like to take this practice moment now, or skip it?
        {/if}
    </p>
    <PopupButtons>
        <Button
            go={() => {
                return info.onnow()
            }}
        >
            Practice now
        </Button>
        <Button
            color="white"
            go={() => {
                return info.onskip()
            }}
        >
            Skip it
        </Button>
    </PopupButtons>
</Popup>
